import { KoobTooltip } from '@koob/ui';
import { openTripWizard } from '@koob/ui/src/features/tripWizard';
import { useTranslation } from 'react-i18next';
import { useActiveFolder, useKoobStore } from 'store';

// KD-3970: "Design a trip", shown in the app header while no trip is open.
// Without a client folder it is dimmed but stays focusable (aria-disabled, not
// disabled) so the tooltip also shows on keyboard focus; a click still opens
// the folder picker, as in the sidebar (KD-3935).
export default function KoobNavbarDesignTripButton() {
  const { t } = useTranslation('tripDesigner');
  const hasActiveFolder = !!useActiveFolder();
  const setBrowseFoldersOpen = useKoobStore(s => s.setBrowseFoldersOpen);

  return (
    <KoobTooltip
      tip={
        hasActiveFolder ? undefined : (
          <span className="block whitespace-nowrap text-[13px]">
            {t('compose.clientFolderRequired')}
          </span>
        )
      }
      maxWidth={400}
      // Hug the button: the navbar slot is full width, and the tooltip
      // centers on this wrapper.
      className="w-fit"
    >
      <button
        type="button"
        aria-disabled={!hasActiveFolder || undefined}
        onClick={
          hasActiveFolder
            ? openTripWizard
            : () => setBrowseFoldersOpen(true, 'designTrip')
        }
        data-testid="open-trip-designer-button"
        className={[
          'flex h-9 items-center gap-2 whitespace-nowrap rounded-md border border-solid px-3.5 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring',
          hasActiveFolder
            ? 'cursor-pointer border-border bg-white text-foreground hover:bg-muted'
            : 'cursor-default border-zinc-100 bg-zinc-50 text-zinc-400',
        ].join(' ')}
      >
        <i
          className={[
            'fa-regular fa-pen-ruler',
            hasActiveFolder ? 'text-brand' : 'text-zinc-300',
          ].join(' ')}
        />
        {t('title')}
      </button>
    </KoobTooltip>
  );
}
